import React from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import ResumeAnalyzer from "./ResumeAnalyzer";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/erp/ai-interview" },
  { label: "New Interview", path: "/erp/ai-interview/setup" },
  { label: "Resume Analyzer", path: "/erp/ai-interview/resume" },
  { label: "Voice Interview", path: "/erp/ai-interview/voice" },
];

export default function AiInterviewLayout() {
  const navigate = useNavigate();

  return (
    <div style={styles.shell}>
      <aside style={styles.sidebar}>
        <div style={styles.logoRow}>
          <div style={styles.logoBadge}>🎭</div>
          <div>
            <p style={styles.logoTitle}>AI Interview</p>
            <p style={styles.logoSub}>Rehearse. Perform. Improve.</p>
          </div>
        </div>
        <nav style={styles.nav}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/erp/ai-interview"}
              style={({ isActive }) => ({
                ...styles.navItem,
                ...(isActive ? styles.navItemActive : {}),
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      <main style={styles.main}>
        <header style={styles.topbar}>
          <div />
          <button style={styles.cta} onClick={() => navigate("/erp/ai-interview/setup")}>
            + New Interview
          </button>
        </header>
        <div style={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}

const styles = {
  shell: {
    display: "flex",
    minHeight: "100vh",
    background: "#10151F",
    fontFamily: "'IBM Plex Sans', sans-serif",
  },
  sidebar: {
    width: "240px",
    background: "#0C1019",
    borderRight: "1px solid #1E2534",
    padding: "24px 18px",
    flexShrink: 0,
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "32px",
    paddingLeft: "6px",
  },
  logoBadge: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "#1B2231",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  },
  logoTitle: {
    color: "#EFEAE1",
    fontWeight: 700,
    fontSize: "13px",
    margin: 0,
  },
  logoSub: {
    color: "#6B7488",
    fontSize: "10px",
    margin: 0,
  },
  nav: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  navItem: {
    color: "#8A93A6",
    textDecoration: "none",
    fontSize: "13px",
    padding: "10px 14px",
    borderRadius: "10px",
    fontWeight: 500,
  },
  navItemActive: {
    background: "#1B2231",
    color: "#C99A4B",
    fontWeight: 700,
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  topbar: {
    height: "64px",
    borderBottom: "1px solid #1E2534",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 28px",
    flexShrink: 0,
  },
  cta: {
    background: "#C99A4B",
    color: "#10151F",
    border: "none",
    borderRadius: "10px",
    padding: "10px 18px",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
  },
  content: {
    flex: 1,
    overflowY: "auto",
  },
};
